import React from "react";
import strings from "../../helpers/Localization";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators as alertDialogActions } from "../../actions/alertDialog.actions";

const CarouselItem = ({ ad, totalCarouselItems, moveAd, editAd, removeAd }) => {

    const dispatch = useDispatch();

    const currentUser = useSelector((state) => state.currentuser);
    const accessrights = currentUser && currentUser.accessrights ? currentUser.accessrights : null;

    return (
        <div className='carousel-item-container'>
            <div className='carousel-thumb-name'>
                <div className='carousel-thumb'>
                    <img className='carousel-thumb' alt="carousel thumb" src={JSON.parse(ad.thumbMobile).url} />
                </div>
                <div className='carousel-name'>
                    <h3>{strings.NameSlide}</h3>
                    <p>{ad.name}</p>
                </div>
            </div>
            <div className='carousel-button'>
                <h3>{strings.Button}</h3>
                <p>{ad.actionButton ? ad.colorButton : strings.Without}</p>
            </div>
            <div className='carousel-text-button'>
                <h3>{strings.TextButton}</h3>
                <p>{ad.textButton !== "" ? ad.textButton : "·"}</p>
            </div>
            <div className='carousel-link'>
                <h3>{strings.link}</h3>
                <p style={{ maxWidth: "300px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{ad.link !== "" ? ad.link : "·"}</p>
            </div>
            <div className='carousel-action'>
                <ButtonSkaRound
                    type="secondary"
                    isDisabled={ad.position === 0 || !accessrights || accessrights.hasPermission(700, "modify") <= 10}
                    onClick={() => moveAd(ad.id, -1)}
                    nameIcon="arrowUp"
                />
                <ButtonSkaRound
                    type="secondary"
                    isDisabled={ad.position === totalCarouselItems || !accessrights || accessrights.hasPermission(700, "modify") <= 10}
                    onClick={() => moveAd(ad.id, 1)}
                    nameIcon="arrowDown"
                />
                <ButtonSkaRound
                    type="primary"
                    isDisabled={!accessrights || accessrights.hasPermission(700, "modify") <= 10}
                    onClick={() => editAd(ad.id)}
                    nameIcon="edit"
                />
                <ButtonSkaRound
                    type="primary"
                    isDisabled={!accessrights || accessrights.hasPermission(700, "delete") <= 10}
                    onClick={() => {
                        dispatch(alertDialogActions.OpenDialog({
                            title: strings.DeleteAdvertisement,
                            description: strings.AlertRemoveAdvertisement,
                            secondaryLabel: strings.cancel,
                            primaryLabel: strings.confirmDelete,
                            onPrimaryAction: () => {
                                removeAd(ad.id);
                            }
                        }));
                    }}

                    nameIcon="trash"
                />
            </div>
        </div>
    );
};

export default CarouselItem;
